import React, { useState } from "react";
import PaymentFrame from "../../molecules/PaymentFrame";
import Container from "../../atoms/Container";
// @ts-ignore
import { Fade } from "react-reveal";
import Payoff from "../../molecules/Payoff";
import LanguageToggle from "../../molecules/LanguageToggle";
import LanguageSelector from "../../molecules/LanguageSelector";
import LanguageSelection from "../../atoms/LanguageSelect";
import PaymentLogo from "../../atoms/PaymentLogo";
import { getAppThemeName } from "../../../../services/appTheme";
import styled from "styled-components";
import FooterMenu from "../../molecules/FooterMenu";
import IdealPage from "../../atoms/IdealPage";
const Desktop = styled(Container) `
  display: none;

  @media only screen and (min-width: 992px) {
    display: block;
    position: absolute;
    bottom: 40px;
    width: 100%;
  }
`;
const Mobile = styled.div `
  @media only screen and (min-width: 992px) {
      display: none;
  }
`;
const StyledContainer = styled(Container) `
  @media only screen and (max-width: 475px) {
    height: 100%;
  }
  @media only screen and (max-width: 576px) {
    width: 100%;
  }
`;
const Payment = props => {
    const [isExpanded, setExpanded] = useState(false);
    const appTheme = getAppThemeName();
    const isInvoned = appTheme === 'invoned';
    return (React.createElement(IdealPage, null,
        React.createElement(StyledContainer, null,
            !isInvoned && React.createElement(PaymentLogo, Object.assign({ appTheme: getAppThemeName() }, props)),
            React.createElement(LanguageSelection, { isAuthVersion: true, hideOnMobile: true },
                React.createElement(LanguageToggle, { onClick: () => setExpanded(prevToggle => !prevToggle) }),
                React.createElement(LanguageSelector, { isExpanded: isExpanded, isReversed: true })),
            React.createElement(Fade, { bottom: true, distance: "80px", delay: 200 },
                React.createElement(PaymentFrame, Object.assign({ appTheme: getAppThemeName() }, props))),
            !isInvoned &&
                React.createElement(React.Fragment, null,
                    React.createElement(Payoff, { variant: true }),
                    React.createElement(Mobile, null,
                        React.createElement(FooterMenu, null)))),
        !isInvoned && React.createElement(Desktop, null,
            React.createElement(FooterMenu, null))));
};
export default Payment;
